import { render, staticRenderFns } from "./LocalSearch.vue?vue&type=template&id=5a5f824a&"
import script from "./LocalSearch.vue?vue&type=script&lang=js&"
export * from "./LocalSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports